import H2Text from './H2Text';

export default H2Text;
